import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const BalanceSheet = () => {
  const getQuerys = async (dimdate) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');
    var queryjson = [];
    queryjson[0] = dimdate;
    let filter = { DimDateKey: queryjson };

    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/balancesheet/${company_id}/${company_org_id}/querys${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getQuerys,
  };
};

export default BalanceSheet();
